import { Card } from "@/src/components/cards";
import { Avis, FolderItem, Patient } from "@/src/data/allTypes";
import { formatDate, getDayCount, getUserShortName } from "@/src/utils/utils";
import { openEvolutionVisualisationDrawer } from "../openEvolutionVisualisation";

export default function AvisCard({
  parent,
  item,
  patient,
  onChange,
}: {
  parent: FolderItem;
  item: Avis;
  patient: Patient;
  onChange: (item: Avis) => void;
}) {
  let doctor = item.doctor;

  return (
    <Card
      color={"blue"}
      leading={
        <div className=" mtop5 left br mright5">
          <div className="bold">{getDayCount(parent?._date, item._date)}</div>
          <div className="gray">{formatDate(item._date, "HH:mm")}</div>
        </div>
      }
      title={"Avis"}
      subTitle={item.service?.name}
      onClick={async () => {
        await openEvolutionVisualisationDrawer({
          items: [item],
          index: 0,
          patient,
        });
      }}
    >
      <div>Demandé par {getUserShortName(item?.creator)}</div>
      {doctor != null && (
        <div className="bold">Rédigé par {getUserShortName(doctor)}</div>
      )}
    </Card>
  );
}
